import { render, staticRenderFns } from "./BusinessStatusSelector.vue?vue&type=template&id=3d49677f&scoped=true"
import script from "./BusinessStatusSelector.vue?vue&type=script&lang=js"
export * from "./BusinessStatusSelector.vue?vue&type=script&lang=js"
import style0 from "./BusinessStatusSelector.vue?vue&type=style&index=0&id=3d49677f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d49677f",
  null
  
)

export default component.exports